import { css } from 'styled-components';
export var positionAbsolute = function positionAbsolute() {
  var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var right = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var bottom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var left = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  return css(["position:absolute;top:", ";right:", ";bottom:", ";left:", ";"], top, right, bottom, left);
};
export var positionFixed = function positionFixed() {
  var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var right = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var bottom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var left = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  return css(["position:fixed;top:", ";right:", ";bottom:", ";left:", ";"], top, right, bottom, left);
};